import { useQuery } from 'react-query'
import { getUsersGraph, getNetworkUsersGraph } from '../Reports/apis/api-reports'
import { useTeam } from './useTeam'
import { useReports } from '../Context/ReportsContext'
import { useCohorts } from './useCohorts'

export const useUsers = () => {
    const { courseID: courseId } = useTeam()
    const { reportQuery, isNetworkContext, networkId } = useReports()
    const { cohorts } = reportQuery
    const { networkCohorts } = useCohorts()

    // Get courseIds from network cohorts if in network context
    // Filter by selected cohort dates from reportQuery
    // Note: reportQuery.cohorts has YYYY-MM-DD format, nc.startDate has ISO format
    // If cohorts is empty, use all available networkCohorts (initial state)
    const selectedCohortIds = isNetworkContext
        ? networkCohorts
            ?.filter((nc) =>
                cohorts?.length === 0 || cohorts?.includes(nc.startDate.substring(0, 10))
            )
            .map((c) => c.courseIdMongo) || []
        : []

    // Choose API based on context
    const fetchFunction = isNetworkContext
        ? () => getNetworkUsersGraph({ networkId: networkId as string, cohorts: selectedCohortIds })
        : () => getUsersGraph({ courseId: courseId as string, cohorts })

    // Build query key
    const queryKey = isNetworkContext
        ? [networkId, 'Network Reports', 'Users', 'Graphs', `Cohorts: ${selectedCohortIds.join()}`]
        : [courseId, 'Reports', 'Users', 'Graphs', `Cohorts: ${cohorts?.join()}`]

    const { data: usersGraph, ...rest } = useQuery(queryKey, fetchFunction, {
        enabled: isNetworkContext ? !!networkId && selectedCohortIds.length > 0 : !!courseId && !!cohorts,
        staleTime: isNetworkContext ? 0 : 1000 * 60 * 60, // No cache for network context to allow immediate refetch
    })

    return { usersGraph, ...rest }
}
